import { createAction } from 'redux-actions';

export const MOVE_FOLDER = 'MOVE_FOLDER';

export default createAction(MOVE_FOLDER);
